import React from "react";
import { FileText } from "lucide-react";
import { siteContact } from "@/config/site";
import LegalPage, { LegalSection, LegalList, LegalContactBox } from "@/components/shared/LegalPage";

const TermsConditions = () => {
  return (
    <LegalPage
      eyebrow="Legal"
      eyebrowIcon={FileText}
      title={<>Terms & <span className="gradient-text">Conditions</span></>}
      lastUpdated="January 2026"
    >
      <LegalSection title="1. Acceptance of Terms">
        <p>
          By accessing and using the services provided by NameSpace Consultants ("Company", "we", "us", or "our"),
          you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to
          abide by these terms, please do not use our services.
        </p>
      </LegalSection>

      <LegalSection title="2. Services Description">
        <p>
          NameSpace Consultants provides AI-powered risk management, loss mitigation, and business consulting services.
          Our services include but are not limited to:
        </p>
        <LegalList>
          <li>Risk assessment and analysis</li>
          <li>Loss mitigation strategies</li>
          <li>Business process optimization</li>
          <li>AI-driven insights and recommendations</li>
          <li>Audit workflow management</li>
        </LegalList>
      </LegalSection>

      <LegalSection title="3. User Obligations">
        <p>You agree to use our services only for lawful purposes and in accordance with these Terms. You agree not to:</p>
        <LegalList>
          <li>Use our services in any way that violates any applicable law or regulation</li>
          <li>Attempt to gain unauthorized access to our systems or networks</li>
          <li>Interfere with or disrupt the integrity or performance of our services</li>
          <li>Transmit any malicious code or harmful content</li>
        </LegalList>
      </LegalSection>

      <LegalSection title="4. Intellectual Property">
        <p>
          All content, features, and functionality of our services, including but not limited to text, graphics,
          logos, icons, images, audio clips, digital downloads, data compilations, and software, are the exclusive
          property of NameSpace Consultants and are protected by international copyright, trademark, patent, trade
          secret, and other intellectual property laws.
        </p>
      </LegalSection>

      <LegalSection title="5. Confidentiality">
        <p>
          We understand the sensitive nature of business information shared with us. We commit to maintaining strict
          confidentiality of all client data and will not disclose any confidential information to third parties
          without your express written consent, except as required by law.
        </p>
      </LegalSection>

      <LegalSection title="6. Limitation of Liability">
        <p>
          To the fullest extent permitted by applicable law, NameSpace Consultants shall not be liable for any
          indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues,
          whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses.
        </p>
      </LegalSection>

      <LegalSection title="7. Indemnification">
        <p>
          You agree to defend, indemnify, and hold harmless NameSpace Consultants and its officers, directors,
          employees, contractors, agents, licensors, and suppliers from and against any claims, liabilities,
          damages, judgments, awards, losses, costs, expenses, or fees arising out of your violation of these
          Terms or your use of our services.
        </p>
      </LegalSection>

      <LegalSection title="8. Governing Law">
        <p>
          These Terms shall be governed by and construed in accordance with the laws of India. Any disputes arising
          under these Terms shall be subject to the exclusive jurisdiction of the courts located in New Delhi, India.
        </p>
      </LegalSection>

      <LegalSection title="9. Changes to Terms">
        <p>
          We reserve the right to modify or replace these Terms at any time. If a revision is material, we will
          provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change
          will be determined at our sole discretion.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact Information">
        <p>If you have any questions about these Terms, please contact us at:</p>
        <LegalContactBox
          name="NameSpace Consultants"
          address={siteContact.address.full}
          email={siteContact.email}
          phone={siteContact.phone}
        />
      </LegalSection>
    </LegalPage>
  );
};

export default TermsConditions;
